import React from 'react';
import styled from 'styled-components';
import logo from '../assets/logo.png';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 20px;
`;

const Img = styled.img`
  height: 40px;
  max-width: 200px;
  object-fit: contain;
  pointer-events: none;
  filter: brightness(1.0) drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
  transition: transform 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
  }
`;

const BrandText = styled.span`
  color: var(--cl-primary);
  font-family: 'Rubik', sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin-left: 12px;
  letter-spacing: 0.5px;
`;

const Logo = () => {
  return (
    <LogoContainer>
      <Img src={logo} alt="ContinuumLink" />
      <BrandText>Health Monitor</BrandText>
    </LogoContainer>
  );
};

export default Logo;
